<ng-template #loadingNotificationTemplate>
  <div class="loading-notification">
    <nz-spin [nzSpinning]="true"></nz-spin>
    <div>
      {{loadingText}}
    </div>
  </div>
</ng-template>
